import i18n from "../i18n";
import {
  traditionalChineseButtonPatterns,
  traditionalChineseButtonText,
} from "../locales/buttonTranslations";

export function buttonText(value) {
  if (typeof value !== "string") return value;
  if ((i18n.resolvedLanguage || i18n.language) !== "zh-TW") return value;

  const directTranslation = traditionalChineseButtonText[value];
  if (directTranslation) return directTranslation;

  const pattern = traditionalChineseButtonPatterns.find(([source]) =>
    source.test(value)
  );
  return pattern ? value.replace(pattern[0], pattern[1]) : value;
}
